import { readFlagValue } from '@tundr/feature-flags';

/** Single GrowthBook flag gating the whole RBAC capability HR-side. */
export const PERMISSIONS_FLAG_KEY = 'authorization.permission-guard' as const;

/**
 * Single, centralized accessor for the RBAC feature flag.
 *
 * Every callsite (store getter, store action, polling composable) goes
 * through this function. When the flag is retired:
 *
 * 1. Inline `true` at the 3 callsites and delete this file.
 * 2. Remove `'authorization.permission-guard'` from
 *    `libraries/feature-flags/src/lib/registry.ts`.
 */
export const isPermissionGuardEnabled = (): boolean =>
  readFlagValue(PERMISSIONS_FLAG_KEY);

export const ROLES_UI_FLAG_KEY = 'authorization.roles-ui' as const;

export const isRolesUiEnabled = (): boolean => readFlagValue(ROLES_UI_FLAG_KEY);
